"use client";

import Image from "next/image";
import { useTranslation } from "react-i18next";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export default function AboutParallaxSection() {
  const { t } = useTranslation();
  const sectionRef = useRef<HTMLElement>(null);
  const prefersReducedMotion = useReducedMotion();

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });

  const y = useTransform(
    scrollYProgress,
    [0, 1],
    prefersReducedMotion ? ["0%", "0%"] : ["-12%", "12%"]
  );

  return (
    <section
      ref={sectionRef}
      className="relative min-h-[280px] w-full overflow-hidden sm:min-h-[360px] md:min-h-[450px] lg:min-h-[550px]"
      aria-label={t("images.aboutParallaxAria")}
    >
      <motion.div
        className="absolute inset-0 h-[125%] w-full min-w-full -top-[12.5%] will-change-transform"
        style={{ y }}
      >
        <Image
          src="/hero1.jpeg"
          alt={t("images.aboutParallax")}
          fill
          sizes="100vw"
          className="object-cover object-center"
          quality={75}
          loading="lazy"
        />
      </motion.div>
    </section>
  );
}
